import DatePicker from "../DatePicker";
import style from "./style.module.scss";
import { IntegerNumber } from "../../components/Input";
import Required from "../Required";

export default function EventDate(props) {
  const { name, date, onChangeDate, isSingle, number, onChangeNumber, required } = props;
  return (
    <div
      className={style.eventDate}
      data-new-component={true}
      data-required={required}
      data-required-valid={required && (!!number || !!date)}
      {...props}
    >
      <div className={style.eventDate_label}>
        <span>{name}</span>
        {required && !(!!date || !!number) ? <Required /> : ""}
      </div>
      <div className={style.eventDate_date}>
        {!isSingle ? (
          <DatePicker
            selected={!!date ? date : ""}
            placeholderText="Data Prevista"
            changeDate={onChangeDate}
            className="text-right"
          />
        ) : (
          <IntegerNumber value={number} valueChange={onChangeNumber} {...props} />
        )}
      </div>
    </div>
  );
}
